export const ssoGQLFields = () => `
  authorizationUrl
  buttonText
  clientId
  clientSecret
  idpUrl
  logoutUrl
  name
  provider
  scopes
  settingsUrl
  signUpUrl
  status
  tokenUrl
  type
  userProfileUrl
  defaultRelayState
  allowSignUp
`;
//# sourceMappingURL=sso.fields.js.map